export default {
  defaultParams: {
    limit: 8,
    page: 1,
    status: 'new',
  },
  defaultScannableTypes: [
    'letter',
    'large envelope',
    'post card'
  ],
  nonRevertableActions: [
    'forward',
    'pick_up',
    'shred',
    'mark_as_pick_up',
  ],
  actions: {
    check_deposit: {
      name: 'check_deposit',
      btn: {
        icon: 'icon-action-check-deposit',
        text: 'Request Check Deposit',
        textAdmin: 'Check deposited',
        // groupText: 'Check Deposited'
      },
      data: {
        pending: {
          field: 'is_check_deposit_requested',
          text: 'Check deposit requested',
        },
        processed: {
          field: 'is_check_deposit_completed',
          text: 'Check deposited',
        },
        conditions: {
          plan: [
            {
              field: 'mail_service_enabled',
              text: 'Not supported in your plan'
            },
            {
              field: 'check_deposit_service_enabled',
              text: 'Not supported in your plan'
            }
          ],
          item: [
            {
              not: true,
              onlyCustomer: true,
              field: 'is_check_deposit_requested',
              text: 'Can\'t process action, check deposit is requested'
            },
            {
              not: true,
              field: 'is_check_deposit_completed',
              text: 'Can\'t process action, check is deposited'
            },
            {
              onlyAdmin: true,
              field: 'is_customer_plan_supports_check_deposit',
              text: 'Feature disabled, you may enable it in the plan settings"'
            },
            {
              onlyAdmin: true,
              field: 'is_customer_enabled_check_deposit_service',
              text: 'Feature disabled. The customer needs to enable this service',
            },
            {
              onlyCustomer: true,
              field: 'is_customer_enabled_check_deposit_service',
              text: 'Feature disabled. You can enable it from your account settings\' Additional Services tab',
            },
            {
              onlyCustomer: true,
              field: 'is_scan_complete',
              text: 'Can\'t process action, item is not scanned yet'
            },
          ],
        }
      },
      cancelText: 'Cancel check deposit',
      text: 'Check deposited',
    },
    scan: {
      name: 'scan',
      btn: {
        icon: 'icon-action-scan',
        text: 'Request Open & Scan',
        textAdmin: 'Scan Mail'
      },
      data: {
        pending: {
          field: 'is_scan_requested',
          alt_fields: ['is_same_day_scan_requested', 'is_two_days_scan_requested'],
          text: 'Scan requested',
        },
        processed: {
          field: 'is_scan_complete',
          text: 'Scanned',
        },
        conditions: {
          item: [
            {
              field: 'is_scannable',
              text: 'Item is not scannable'
            }
          ],
          plan: [
            {
              field: 'mail_service_enabled',
              text: 'Not supported in your plan'
            },
            {
              field: 'has_mail_scanning',
              text: 'Not supported in your plan'
            }
          ]
        },
        result: {
          field: 'scan_url',
          text: 'Download scan'
        }
      },
      options: {
        scan_delivery_type: [
          {
            name: 'standard_scan', 
            title: 'Standard scan',
            descr: '3-4 days',
            price_field: 'price_per_scan'
          },
          {
            name: 'same_day_scan', 
            title: 'Same day scan',
            price_field: 'price_same_day_scan'
          },
          {
            name: 'two_days_scan', 
            title: '2 days scan',
            price_field: 'price_two_days_scan'
          }
        ]
      },
      // planOptionsDisableField: 'expedited_scan_service_enabled',
      cancelText: 'Cancel Scan'
    },
    forward: {
      name: 'forward',
      btn: {
        icon: 'icon-action-forward',
        text: 'Request Forward',
        textAdmin: 'Forward Mail'
      },
      data: {
        pending: {
          field: 'is_forward_requested',
          text: 'Forwarding requested',
        },
        processed: {
          field: 'is_forward_complete',
          text: 'Forwarded',
        },
        conditions: {
          plan: [
            {
              field: 'mail_service_enabled',
              text: 'Not supported in your plan'
            },
            {
              field: 'has_mail_forwarding',
              text: 'Not supported in your plan'
            }
          ],
          local: [
            {
              field: 'forwardAddresses',
              text: 'No Forward Address'
            }
          ],
          item: [
            {
              field: 'is_active_customer',
              text: 'Cannot forward mail item to an inactive customer',
              onlyAdmin: true,
            }
          ]
        }
      },
      options: {
        forward_address_id: [],
        delivery_days: [
          {
            title: 'Standard shipping',
            days: 0
          },
          {
            title: 'Next day delivery',
            days: 1
          },
          {
            title: '2 days delivery',
            days: 2
          },
          {
            title: '3 days delivery',
            days: 3
          }
        ]
      },
      cancelText: 'Cancel Forward'
    },
    pick_up: {
      name: 'pick_up',
      btn: {
        icon: 'icon-action-mail-pick-customer',
        text: 'Request Hold for Pick up',
        textAdmin: 'Picked up',
        groupText: 'Hold for pick up'
      },
      data: {
        pending: {
          field: 'is_pick_up',
          text: 'Pick up requested',
        },
        processed: {
          field: 'is_pick_up_complete',
          text: 'Picked up',
        },
        conditions: {
          plan: [
            {
              field: 'mail_service_enabled',
              text: 'Not supported in your plan'
            },
            {
              field: 'pickup_enabled',
              text: 'Not supported in your plan'
            }
          ]
        }
      },
      options: {
        schedule_field: 'pick_up_scheduled_at'
      },
      clientOptionsDisableField: 'pick_up_scheduling_enabled',
      cancelText: 'Cancel Pick Up',
      text: 'Picked Up',
    },
    mark_as_pick_up: {
      name: 'mark_as_pick_up',
      btn: {
        icon: 'icon-action-mail-pick',
        text: 'Mark as Picked Up',
        groupText: 'Mark as Picked up'
      },
      data: {
        pending: {
          field: 'mark_as_pick_up_requested',
          text: 'Mark as Picked up requested',
        },
        processed: {
          field: 'mark_as_pick_up_complete',
          text: 'Mark as Picked up complete',
        },
      },
      cancelText: 'Cancel Mark as Picked Up'
    },
    pick_up_signature: {
      name: 'pick_up_signature',
      btn: {
        icon: 'icon-action-signed',
        text: 'Request Pick up Signature',
        textAdmin: 'Pick up Signature'
      },
      data: {
        pending: {

        },
        processed: {

        },
      },
    },
    shred: {
      name: 'shred',
      btn: {
        icon: 'icon-action-shred',
        text: 'Request Shred',
        textAdmin: 'Shred'
      },
      data: {
        pending: {
          field: 'is_shred_requested',
          text: 'Shred requested',
        },
        processed: {
          field: 'is_shred_complete',
          text: 'Shredded',
        },
        conditions: {
          plan: [
            {
              field: 'has_letter_shredding',
              text: 'Not supported in your plan'
            }
          ]
        }
      },
      cancelText: 'Cancel Shred'
    },
    picture: {
      name: 'picture',
      btn: {
        icon: 'icon-action-foto',
        text: 'Request envelope picture',
        textAdmin: 'Add Envelope Picture'
      },
      data: {
        pending: {
          field: 'picture_requested_at',
          text: 'Envelope picture requested'
        },
        processed: {
          field: 'picture_added_at',
          text: 'Envelope picture available'
        },
        result: {
          field: 'picture_url',
          text: 'Download envelope picture'
        },
        conditions: {
          item: [
            {
              onlyCustomer: true,
              not: true,
              field: 'is_scan_complete',
              text: 'Can\'t process action, item is scanned'
            },
          ],
        }
      },
      cancelText: 'Cancel Envelope Picture',
      options: {},
      planOptionsDisableField: 'mail_item_picture_price'
    },
    junk: {
      name: 'junk',
      btn: {
        icon: 'icon-action-spam',
        text: 'Junk Mail',
      },
      data: {
        pending: {
          text: 'Junk Mail'
        },
        processed: {

        },
        admin_status: {
          icon: 'icon-action-revert-spam',
          text: 'Not Junk',
          value: 'junk'
        }
      },
      options: {
        trash_now: {
          admin: [
            {
              value: false, 
              title: 'Discard mail after 30 days',
              descr: 'Move to Junk Mail (storage fees will apply)',
            },
            {
              value: true, 
              title: 'Discard mail now',
              descr: 'You cannot undo this action'
            },
          ],
          customer: [
            {
              value: false, 
              title: 'Discard mail after 30 days',
              descr: 'Storage fees will apply',
            },
            {
              value: true, 
              title: 'Discard mail now',
              descr: 'Request to discard mail item '
            },
          ]
        }
      },
      cancelText: 'Not Junk',
      trashText: 'Request to discard mail item'
    },
    edit: {
      name: 'edit',
      btn: {
        icon: 'icon-action-mail-edit',
        text: 'Edit mail'
      },
      data: {
        pending: {},
        processed: {}
      }
    },

    // TEMP
    default: {
      name: 'default',
      btn: {
        icon: 'icon-action-spam',
        text: 'Perform action'
      },
      cancelText: 'Cancel action'
    },
    cancel_mark_as_pick_up: {
      name: 'cancel_mark_as_pick_up',
      btn: {
        icon: 'icon-arrow-round',
        text: 'Reject as Picked Up',
      },
      data: {
        pending: {
          
        },
        processed: {
          
        }
      }
    },
    trash_now: {
      name: 'trash_now',
      btn: {
        icon: 'icon-action-trash',
        text: 'Discard now',
      },
      data: {
        pending: {
          text: 'Marked as Junk'
        },
        processed: {

        },
        admin_status: {
          icon: 'icon-action-revert-spam',
          text: 'Not Junk',
          value: 'junk'
        }
      },
    },
    cancel_junk: {
      name: 'cancel_junk',
      btn: {
        icon: 'icon-action-revert-spam',
        text: 'Not junk',
      },
      data: {
        pending: {
          text: 'Marked as Junk'
        },
        processed: {

        },
        admin_status: {
          icon: 'icon-action-revert-spam',
          text: 'Not Junk',
          value: 'junk'
        }
      },
    }
  },
  group_actions: {
    forward: {
      name: 'forward',
      btn: {
        icon: 'icon-action-forward',
        text: 'Forward group'
      }
    },
    reminder: {
      name: 'reminder',
      btn: {
        icon: 'icon-action-clock',
        text: 'Set reminder'
      }
    },
    delete: {
      name: 'delete',
      btn: {
        icon: 'icon-action-close',
        text: 'Delete'
      }
    }
  },
  available_actions: {
    customer: {
      single: ['check_deposit', 'picture', 'scan', 'forward', 'pick_up', 'mark_as_pick_up', 'shred', 'junk'],
      group: ['scan', 'forward', 'pick_up', 'mark_as_pick_up', 'picture', 'shred', 'junk']
    },
    admin: {
      single: ['check_deposit', 'picture', 'scan', 'forward', 'pick_up', /*'mark_as_pick_up', */'pick_up_signature', 'shred', 'junk', 'edit'],
      customer_pick_up: ['mark_as_pick_up', 'cancel_mark_as_pick_up', 'edit'],
      junk: ['trash_now', 'cancel_junk'],
      group: [/*'scan', 'forward', */'pick_up', /*'mark_as_pick_up', 'picture', */'shred', 'junk' /*,'pick_up_signature'*/],
      mail_group: ['forward', 'reminder', 'delete']
    }
  }
};
